import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import cn from 'classnames';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Editor from '../../Editor';
import { extConfig } from './config';
import { useEditorContext } from '../../Context';
import presetViewerStyles from '../../../Viewer/presets/Status/Status.scss';
import s from './Status.scss';
const StatusEditor = (_param)=>{
    var { isShortStatus = false, children } = _param, props = _object_without_properties(_param, [
        "isShortStatus",
        "children"
    ]);
    const { t } = useTranslation('editor');
    const editor = useEditorContext();
    const focusEditor = useCallback((e)=>{
        if (e.target && e.target.parentElement.getAttribute('data-wrapper') && !(editor === null || editor === void 0 ? void 0 : editor.isFocused) && (editor === null || editor === void 0 ? void 0 : editor.isEmpty)) {
            editor === null || editor === void 0 ? void 0 : editor.commands.focus('end');
        }
    }, [
        editor === null || editor === void 0 ? void 0 : editor.commands,
        editor === null || editor === void 0 ? void 0 : editor.isEmpty,
        editor === null || editor === void 0 ? void 0 : editor.isFocused
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        "data-wrapper": "1",
        onClick: focusEditor,
        className: s['focus']
    }, /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
        withinModal: true,
        presetId: "status",
        className: cn(s['root'], presetViewerStyles['root'], isShortStatus && s['short-status']),
        extensionConfig: extConfig,
        placeholder: t('preset.status.placeholder')
    }), children));
};
StatusEditor.displayName = 'StatusEditor';
export default StatusEditor;

//# sourceMappingURL=Status.js.map